import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { kebabCase } from "lodash";

import PreviewCompatibleImage from "./PreviewCompatibleImage";
import DisplayTags from "./DisplayTags";

export default function DisplayCard(props) {
  const {
    image = null,
    title,
    slug,
    date = "",
    endDate = "",
    excerpt = "",
    showTags = true,
    featured = false,
    tags = [],
    buttonText = "More",
    buttonClass = "button force-right",
    relatedPerson = "",
    relatedPersonSlug = "",
    category = "",
  } = props;

  return (
    <React.Fragment>
      <div className="display-card">
        <article
          id={slug}
          className={`blog-list-item tile is-child box notification ${
            featured ? "is-featured" : ""
          }`}
        >
          <div>
            {image ? (
              <div>
                <Link
                  className="title has-text-primary is-size-4 no-underline"
                  to={slug}
                  title={title}
                >
                  <PreviewCompatibleImage
                    imageInfo={{
                      image: image,
                      alt: title,
                      className: "featured-image",
                    }}
                  />
                </Link>
              </div>
            ) : null}

            <h2 className="post-meta title is-size-3 has-text-weight-bold is-bold-light">
              <Link
                className="title has-text-primary is-size-4 no-underline"
                to={slug}
              >
                {title}
              </Link>
            </h2>
            {date || relatedPerson ? (
              <h3 className="subtitle is-size-6 is-block">
                {renderAuthorDate(
                  date,
                  endDate,
                  relatedPerson,
                  relatedPersonSlug,
                  category
                )}
              </h3>
            ) : null}
          </div>

          {excerpt ? <div className="content">{excerpt}</div> : null}
          <div className="taglist-outer">
            <DisplayTags tags={tags} showTags={showTags} />
          </div>

          <br className="clear" />
          <p className="post-link">
            <Link className={buttonClass} to={slug}>
              {buttonText}
            </Link>
            <br className="clear" />
          </p>
        </article>
      </div>
    </React.Fragment>
  );
}

DisplayCard.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  date: PropTypes.string,
  featured: PropTypes.bool,
  showTags: PropTypes.bool,
  tags: PropTypes.array,
  buttonText: PropTypes.string,
  buttonClass: PropTypes.string,
  relatedPerson: PropTypes.string,
  relatedPersonSlug: PropTypes.string,
};

function renderAuthorDate(
  date,
  endDate,
  relatedPerson,
  relatedPersonSlug,
  category
) {
  if (endDate) {
    date = date + " - " + endDate;
  }

  if (date && relatedPerson && relatedPersonSlug) {
    return (
      <span>
        {renderCategory(category)}
        <Link
          to={relatedPersonSlug}
          title={relatedPerson}
          className="no-underline"
        >
          {relatedPerson}
        </Link>
        , {date}
      </span>
    );
  } else if (date && relatedPerson) {
    return (
      <span>
        {renderCategory(category)} {relatedPerson}, {date}
      </span>
    );
  } else if (date) {
    return <span>{date}</span>;
  }
}

function renderCategory(category) {
  if (category) {
    return (
      <>
        <Link to={`/category/${kebabCase(category)}/`}>{category}</Link> -{" "}
      </>
    );
  }
}
